import { Controller } from "@hotwired/stimulus";

// LOC-101: an image frame in the portfolio item popup. The frame is a fixed 3:2
// box; only a portrait image (taller than wide) gets its own aspect ratio. The
// stored ProjectFile has no dimensions, so the decision is taken from the
// loaded image itself.
export default class extends Controller {
  static targets = ["image"];
  static classes = ["portrait"];

  connect() {
    if (this.imageTarget.complete) this.measure();
  }

  measure() {
    const image = this.imageTarget;
    if (!image.naturalWidth) return;

    this.element.classList.toggle(this.portraitClass, image.naturalHeight > image.naturalWidth);
  }
}
